import { useEffect, useState, type RefObject } from 'react';
import type { GridApi } from 'ag-grid-community';

export const DASHBOARD_SEARCH_EVENT = 'iptv-dashboard-search';

let lastDashboardSearchQuery = '';

export function getDashboardSearchQuery(): string {
  return lastDashboardSearchQuery;
}

export function rememberDashboardSearchQuery(q: string): void {
  lastDashboardSearchQuery = q;
}

/** Top-bar “Search…” dispatches `iptv-dashboard-search` with detail string (legacy globalSearch). */
export function useDashboardSearchQuery(): string {
  const [q, setQ] = useState(lastDashboardSearchQuery);
  useEffect(() => {
    const onSearch = (ev: Event) => {
      const d = (ev as CustomEvent<string>).detail;
      const next = typeof d === 'string' ? d : '';
      lastDashboardSearchQuery = next;
      setQ(next);
    };
    window.addEventListener(DASHBOARD_SEARCH_EVENT, onSearch);
    return () => window.removeEventListener(DASHBOARD_SEARCH_EVENT, onSearch);
  }, []);
  return q;
}

/** Flat grids (e.g. Category editor): apply top-bar Search via AG Grid quick filter. */
export function useDashboardGridSearch<T>(apiRef: RefObject<GridApi<T> | null>) {
  useEffect(() => {
    const apply = (text: string) => {
      apiRef.current?.setGridOption('quickFilterText', text);
    };
    apply(lastDashboardSearchQuery);
    const onSearch = (ev: Event) => {
      const d = (ev as CustomEvent<string>).detail;
      const next = typeof d === 'string' ? d : '';
      lastDashboardSearchQuery = next;
      apply(next);
    };
    window.addEventListener(DASHBOARD_SEARCH_EVENT, onSearch);
    return () => window.removeEventListener(DASHBOARD_SEARCH_EVENT, onSearch);
  }, [apiRef]);
}
